import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=d459e57a&"
import script from "./Attestation.vue?vue&type=script&lang=ts&"
export * from "./Attestation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports